module.exports = __webpack_public_path__ + "static/img/language_1_2.95cd489.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faq/language_1_2.jpg
// module id = T5LV
// module chunks = 1